// ─── Contexte : feuille « Modifier l'accès » au NIVEAU ÉCRAN ──────
// La Feuille (calque absolu natif) doit être rendue près de la RACINE de
// l'écran — rendue dans une carte, elle se coince dans la carte. Ce provider
// (posé par EcranProfil) rend UNE FeuilleNiveauAcces globale ; les cartes
// SectionAcces l'ouvrent via le hook au lieu de rendre la leur.
import React, { createContext, useContext, useState } from 'react';
import FeuilleNiveauAcces from './FeuilleNiveauAcces';

const Ctx = createContext(null);

export function FormAccesProvider({ children }) {
  const [form, setForm] = useState(null);
  // form = { mode, cible, cibleNom, titreRessource, niveauInit, niveaux,
  //          membresDispo, onValider(cle, niveau), onRetirer(cle) }
  return (
    <Ctx.Provider value={setForm}>
      {children}
      <FeuilleNiveauAcces
        visible={!!form} mode={form?.mode} cible={form?.cible} cibleNom={form?.cibleNom}
        titreRessource={form?.titreRessource} niveauInit={form?.niveauInit} niveaux={form?.niveaux}
        membresDispo={form?.membresDispo || []}
        onValider={(cle, niveau) => form?.onValider?.(cle, niveau)}
        onRetirer={(cle) => form?.onRetirer?.(cle)}
        onFermer={() => setForm(null)} />
    </Ctx.Provider>
  );
}

// null si aucun provider (repli : la carte rend sa feuille localement).
export const useOuvrirFormAcces = () => useContext(Ctx);
